export const extractStringBetweenParentheses = (str: string) => {
  const match = /\(([^)]+)\)/.exec(str);
  return match?.[1];
};
